import React from 'react';

export const Card = ({ children, className = '', ...props }) => (
  <div className={`bg-white shadow rounded ${className}`} {...props}>
    {children}
  </div>
);

export const CardHeader = ({ children, ...props }) => (
  <div className="p-4 border-b" {...props}>
    {children}
  </div>
);

export const CardTitle = ({ children, className = '', ...props }) => (
  <h2 className={`text-lg font-semibold ${className}`} {...props}>
    {children}
  </h2>
);

export const CardContent = ({ children, ...props }) => (
  <div className="p-4" {...props}>
    {children}
  </div>
);

export const CardDescription = ({ children, className = '', ...props }) => (
  <p className={`text-sm text-gray-500 mt-1 ${className}`} {...props}>
    {children}
  </p>
);

export const CardFooter = ({ children, className = '', ...props }) => (
  <div className={`p-4 pt-0 ${className}`} {...props}>
    {children}
  </div>
);
